module.exports = __webpack_public_path__ + "img/sberbank.a3c8610f.png";